document.addEventListener('DOMContentLoaded', function() {
    initArtInStore();
});

document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList.contains('section-art-in-store') || 
        event.target.querySelector('.art-store-section')) {
        initArtInStore(event.target);
    }
});

document.addEventListener('shopify:block:select', function(event) {
    const sectionContainer = event.target.closest('.section-art-in-store') || 
                            event.target.closest('.art-store-section');
    if (sectionContainer) {
        initArtInStore(sectionContainer);
    }
});

function initArtInStore(container = null) {
    let artStoreSections;
    
    if (container) {
        if (container.classList.contains('art-store-section')) {
            artStoreSections = [container];
        } 
        else if (container.classList.contains('section-art-in-store')) {
            const innerSection = container.querySelector('.art-store-section');
            artStoreSections = innerSection ? [innerSection] : [];
        }
        else {
            const innerSections = container.querySelectorAll('.art-store-section');
            artStoreSections = innerSections.length > 0 ? Array.from(innerSections) : [];
        }
    } else {
        artStoreSections = document.querySelectorAll('.art-store-section');
    }
    
    artStoreSections.forEach(section => {
        const mainImage = section.querySelector('.main-store-img');
        const galleryItems = section.querySelectorAll('.gallery-item');
        const prevArrow = section.querySelector('.gallery-nav-prev');
        const nextArrow = section.querySelector('.gallery-nav-next');

        if (galleryItems.length > 0 && mainImage) {
            let currentIndex = 0;
            let newGalleryItems = [];
            
            function handleGalleryClick(item, index) {
                if (!item) return;
                
                const imgElement = item.querySelector('img');
                if (!imgElement) return;
                
                section.querySelectorAll('.gallery-item').forEach(galleryItem => {
                    galleryItem.classList.remove('gallery-active');
                });
                
                item.classList.add('gallery-active');
                currentIndex = index !== undefined ? index : Array.from(galleryItems).indexOf(item);
                
                const imgSrc = imgElement.getAttribute('src');
                const fullSizeSrc = imgSrc.replace(/(\d+)x/, '1500x');
                
                mainImage.style.opacity = '0.6';
                
                setTimeout(() => {
                    mainImage.setAttribute('src', fullSizeSrc);
                    mainImage.onload = function() {
                        mainImage.style.opacity = '1';
                    };
                    setTimeout(() => {
                        mainImage.style.opacity = '1';
                    }, 300);
                }, 200);

                updateArrowState();
            }
            
            function navigateGallery(direction) {
                const newIndex = currentIndex + direction;
                
                if (newIndex >= 0 && newIndex < galleryItems.length) {
                    handleGalleryClick(newGalleryItems[newIndex], newIndex);
                }
            }

            function updateArrowState() {
                if (prevArrow && nextArrow) {
                    prevArrow.classList.toggle('disabled', currentIndex === 0);
                    nextArrow.classList.toggle('disabled', currentIndex === galleryItems.length - 1);
                }
            }
            
            galleryItems.forEach((item, index) => {
                const newItem = item.cloneNode(true);
                item.parentNode.replaceChild(newItem, item);
                
                newGalleryItems.push(newItem)

                newItem.addEventListener('click', function(e) {
                    e.preventDefault();
                    handleGalleryClick(this, index);
                });
                
                newItem.style.cursor = 'pointer';
            });

            if (newGalleryItems[0]) {
                setTimeout(() => {
                    handleGalleryClick(newGalleryItems[0], 0);
                }, 300);
            }
            
            if (prevArrow) {
                const newPrevArrow = prevArrow.cloneNode(true);
                prevArrow.parentNode.replaceChild(newPrevArrow, prevArrow);
                
                newPrevArrow.addEventListener('click', function(e) {
                    e.preventDefault();
                    navigateGallery(-1);
                });
            }

            if (nextArrow) {
                const newNextArrow = nextArrow.cloneNode(true);
                nextArrow.parentNode.replaceChild(newNextArrow, nextArrow);
                
                newNextArrow.addEventListener('click', function(e) {
                    e.preventDefault();
                    navigateGallery(1);
                });
            }

            updateArrowState();
        }
    });
} 